<div class="p-2 d-flex align-items-center justify-content-between">
    <h2 mat-dialog-title >{{data.title}}</h2>
    
    <button mat-icon-button [mat-dialog-close]="" class="mr-4">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <p>{{data.dataToChange.iconName}}</p>
    <div style="display:flex;flex-wrap:wrap; justify-content:space-between; align-items: center; max-width:500px; ">
        <div *ngFor="let icon of data.allIcons">
            <button mat-button class="mat-button-wrapper mr-1 p-4" *ngIf="icon.iconName==data.dataToChange.iconName" (click)="iconSelected(icon)" style=" background-color:linen;">
                <img cdkFocusInitial class="myicon p-2" [src]="'assets/icons/'+icon.iconAssetName+'.svg'" [alt]="iconAssetName" width="50" height="50" >
            </button>


            <button mat-button class="mat-button-wrapper mr-1 p-4" *ngIf="icon.iconName!=data.dataToChange.iconName" (click)="iconSelected(icon)">
                <img class="p-2" [src]="'assets/icons/'+icon.iconAssetName+'.svg'" [alt]="iconAssetName" width="50" height="50"  >
            </button>
        </div>
        
   
    </div>
</mat-dialog-content>